import styled from 'styled-components';

export const FuturaTarjetaWrapper = styled.div`
._3sTov _35oaN {
    margin: 10px;
}

.t-internacional .subtitulo {
    display: inherit;
}

.texto-tarifas {
    padding-top: 35px;
    margin-left: 40px;
}

.texto-tarifas .subtitulo {
    width: 84%;
    line-height: 18px;
}

.futura-tarjeta-header-gold {
    background: rgb(78, 69, 46);
    background: linear-gradient(
        180deg,
        rgb(16 16 16) 0%,
        rgba(186, 119, 21, 1) 100%
    );
    border-radius: 5px;
    margin: 0px 0 32px 0;
    height: 250px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-content: center;
    padding: 60px 60px 34px 60px;F
    align-items: center;
}

.t-internacional img {
    position: relative;
    left: 30px;
}

.p-internacional {
    color: white;
    font-weight: bold;
}

.Card-Class {
    background: white;
    margin-bottom: 35px;
}

.p-internacional-dos {
    color: white;
}

.t-internacional .titulo {
    font-size: 1.5rem;
    line-height: 1.5;
    font-weight: bold;
    color: white;
}

.t-internacional .subtitulo {
    font-size: 0.9rem;
    color: #ffffff;
}

p.p-internacional-dos {
    position: relative;
    top: 20px;
    font-size: 0.8rem;
    font-weight: 500;
    max-width: 210px;
}

.t-internacional .texto {
    position: relative;
    left: 49px;
    bottom: 76px;
}

.contenedor {
    display: grid;
    justify-content: center;
    align-items: center;
}

.contenedor-gold-card {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    text-align: center;
}

.p-mensaje {
    margin-top: 0.5rem;
    font-size: 0.9rem;
    margin-bottom: 8px;
    font-weight: 600;
}

.info .p-coment {
    font-size: 0.8rem;
    line-height: 17px;
    color: #333333;
}

.contenedor-goldcard .info {
    padding: 10px;
}

.card {
    margin-top: 16px;
    background-color: white;
    border-radius: 5px;
    margin-bottom: 30px;
}

@media (min-width: 768px) {
    .texto-tarifas {
        padding-top: 45px;
    }
}

@media (max-width: 420px) {
    .futura-tarjeta-header-gold {
        margin: 0px -11px -48px -11px;
        height: auto;
    }
    .t-internacional .subtitulo {
        display: none;
    }
}

@media (max-width: 426px) {
    .t-internacional img {
        position: relative;
        left: 0;
        width: 294px;
    }
    .texto-tarifas {
        margin-bottom: 0;
        margin-left: 0;
    }
    .t-internacional .subtitulo {
        display: none;
    }
    .futura-tarjeta-header-gold {
        margin: 0px -10px -52px -10px;
        padding: 10px;
        height: auto;
    }

    .futura-tarjeta-header-gold .t-internacional:nth-child(2) {
        text-align: center;
    }

    .t-internacional .texto {
        width: 200px;
        position: relative;
        left: 42px;
        bottom: 73px;
    }

    .p-internacional-dos {
        text-align: left;
        padding-left: 32px;
        top: 20px !important;
    }

    .futura-tarjeta-header-gold {
        grid-template-columns: 1fr;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) {
        padding: 0 57px 14px;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) .titulo {
        font-size: 1rem;
        margin-left: 40px;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) .subtitulo {
        font-size: 0.9rem;
        line-height: 19px;
        display: none;
    }
    .contenedor-gold-card {
        grid-template-columns: 1fr;
    }
    .contenedor-gold-card {
        gap: 20px;
    }
    .Card-Class h1 {
        font-size: 1.1rem !important;
    }
    .card {
        margin-top: 16px;
    }
}

@media (max-width: 376px) {
    .t-internacional img {
        position: inherit;
        left: 0;
        width: inherit;
    }
    .texto-tarifas {
        margin-bottom: 0;
        margin-left: 0;
    }
    .t-internacional .subtitulo {
        display: none;
    }
    .futura-tarjeta-header-gold {
        margin: 0px -10px -52px -10px;
        padding: 10px;
        height: auto;
    }

    .t-internacional .texto {
        width: 200px;
        position: relative;
        left: 21px;
        bottom: 72px;
    }

    p.p-internacional-dos {
        text-align: left;
        padding-left: 30px;
        top: 16px !important;
    }

    .futura-tarjeta-header-gold .t-internacional:nth-child(2) {
        text-align: center;
    }
    .futura-tarjeta-header-gold {
        grid-template-columns: 1fr;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) {
        padding: 0 33px 14px;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) .titulo {
        font-size: 1rem;
        margin-left: 20px;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) .subtitulo {
        font-size: 0.9rem;
        line-height: 19px;
        display: none;
    }
    .contenedor-gold-card {
        grid-template-columns: 1fr;
    }
    .contenedor-gold-card {
        gap: 20px;
    }
    .Card-Class h1 {
        font-size: 1.1rem !important;
    }
    .card {
        margin-top: 16px;
    }
}

@media (max-width: 321px) {
    .t-internacional img {
        position: relative;
        left: 0;
        width: inherit;
    }
    .texto-tarifas {
        margin-bottom: 0;
        margin-left: 0;
    }
    .futura-tarjeta-header-gold {
        margin: 0px -10px -52px -10px;
        padding: 10px;
        height: auto;
    }

    .t-internacional .texto {
        width: 200px;
        position: relative;
        left: -9px;
        bottom: 73px;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(2) {
        text-align: center;
    }
    .futura-tarjeta-header-gold {
        grid-template-columns: 1fr;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) {
        padding: 5px 4px 14px;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) .titulo {
        font-size: 1rem;
        margin-left: 0px;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) .subtitulo {
        font-size: 0.9rem;
        line-height: 19px;
        display: none;
    }
    .contenedor-gold-card {
        grid-template-columns: 1fr;
    }
    .contenedor-gold-card {
        gap: 20px;
    }
    .Card-Class h1 {
        font-size: 1.1rem !important;
    }
    .card {
        margin-top: 16px;
    }
    .t-internacional .texto {
        width: 200px;
        position: relative;
        left: -5px;
        bottom: 74px;
    }
    .t-internacional .subtitulo {
        display: none;
    }
}
`;

export default FuturaTarjetaWrapper;